export default "__VITE_ASSET__woNGpIg6__"